// extracted by mini-css-extract-plugin
module.exports = {"all":"index-module_all_1BjcM"};